(() => {
  const loader = document.getElementById('jc-page-transition-loader');

  if (!loader) {
    return;
  }

  const root = document.documentElement;

  const showLoader = () => {
    loader.hidden = false;
    loader.setAttribute('aria-hidden', 'false');
    root.classList.add('jc-page-transition-is-loading');
  };

  const hideLoader = () => {
    loader.hidden = true;
    loader.setAttribute('aria-hidden', 'true');
    root.classList.remove('jc-page-transition-is-loading');
  };

  const isPageNavigation = (link) => {
    if (
      link.hasAttribute('download') ||
      link.target.toLowerCase() === '_blank' ||
      link.closest('[data-no-page-transition-loader]')
    ) {
      return false;
    }

    let destination;

    try {
      destination = new URL(link.href, window.location.href);
    } catch (error) {
      return false;
    }

    if (!['http:', 'https:'].includes(destination.protocol) || destination.origin !== window.location.origin) {
      return false;
    }

    const currentWithoutHash = `${window.location.pathname}${window.location.search}`;
    const destinationWithoutHash = `${destination.pathname}${destination.search}`;

    return currentWithoutHash !== destinationWithoutHash;
  };

  document.addEventListener('click', (event) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    const link = target ? target.closest('a[href]') : null;

    if (link && isPageNavigation(link)) {
      queueMicrotask(() => {
        if (!event.defaultPrevented) {
          showLoader();
        }
      });
    }
  });

  document.addEventListener('submit', (event) => {
    if (event.defaultPrevented || !(event.target instanceof HTMLFormElement)) {
      return;
    }

    const form = event.target;

    if (
      form.target.toLowerCase() === '_blank' ||
      form.closest('[data-no-page-transition-loader]')
    ) {
      return;
    }

    let destination;

    try {
      destination = new URL(form.action || window.location.href, window.location.href);
    } catch (error) {
      return;
    }

    if (destination.origin === window.location.origin) {
      queueMicrotask(() => {
        if (!event.defaultPrevented) {
          showLoader();
        }
      });
    }
  });

  window.addEventListener('pageshow', hideLoader);
  hideLoader();
})();
